import WRAP from 'WRAP-JS';
import { groupBy, orderBy } from "lodash-es";

export const deepCopy = (obj) => {
  return JSON.parse(JSON.stringify(obj));
}
export const formatLonLatDM = (lon, lat) => {
  return `${formatLatDM(lat)} ${formatLonDM(lon)}`;
};
export const formatLatDM = (lat) => {
  return `${fmtDM(lat)}′${nsew(lat, true)}`;
};
export const formatLonDM = (lon) => {
  return `${fmtDM(lon)}′${nsew(lon,false)}`;
};
export const formatLonLatATC1 = (lon, lat) => {
  const _lon = splitDMS(lon);
  const _lat = splitDMS(lat);
  // e.g. "4620N07805W"
  return (
    ("00" + _lat[1]).slice(-2) +
    ("00" + (_lat[2] + Math.round(_lat[3] / 60))).slice(-2) +
    (_lat[0] >= 0 ? "N" : "S") +
    ("000" + _lon[1]).slice(-3) +
    ("00" + (_lon[2] + Math.round(_lon[3] / 60))).slice(-2) +
    (_lon[0] >= 0 ? "E" : "W")
  );
}
export const formatLonLatATC2 = (lon, lat) => {
  const _lon = splitDMS(lon);
  const _lat = splitDMS(lat);
  // e.g. "46N078W"
  return (
    ("00" + (_lat[1] + Math.round(_lat[2] / 60))).slice(-2) +
    (_lat[0] >= 0 ? "N" : "S") +
    ("000" + (_lon[1] + Math.round(_lon[2] / 60))).slice(-3) +
    (_lon[0] >= 0 ? "E" : "W")
  );
}

export const getPerspective = (plan) => {
  if (!plan.route) return;
  let points = convertRouteToWRAPPoints(plan.route);
  points.push(convertWRAPPoint(plan.dep.lat, plan.dep.lon));
  points.push(convertWRAPPoint(plan.arr.lat, plan.arr.lon));
  const perspective =  WRAP.Geo.getPerspective(points, 85);

  return {
    centerLat: m2d(perspective.center.lat),
    centerLon: m2d(perspective.center.lon),
    zoom: perspective.fractional_zoom
  }
};

export const isReverseRoute = (depLon, arrLon) => {
  let d_lon = arrLon - depLon;
  if ( d_lon < 0 ) {
    d_lon += 360.0;
  } else if ( d_lon >= 360.0 ) {
    d_lon -= 360.0;
  }
  return d_lon > 180.0;
}

/**
 * プランのルート配列をWRAP.Geo.Pointの配列に変換する.
 * @param {Array} route プランのルート配列
 * @returns {Array} WRAP.Geo.Pointの配列に変換する
 */
export const convertRouteToWRAPPoints = (route) => {
  const _route = route || [];
  return _route.flatMap((point) => {
    if (point.airway) {
      return point.airway.reduce((list, ap) => {
        list.push(convertWRAPPoint(ap.lat, ap.lon));
        return list;
      },[]);
    } else {
      return convertWRAPPoint(point.lat, point.lon)
    }
  });
};

/**
 * 指定された緯度経度をWRAP.Geo.Pointに変換する
 * @param {number} lat 緯度
 * @param {number} lon 経度
 * @return {WRAP.Geo.Point}
 */
export const convertWRAPPoint = (lat, lon) =>{
  return new WRAP.Geo.Point(d2m(lat), d2m(lon));
};

/**
 * 星型のシンボルを描画するための座標配列を返却する.
 * @param {number} size サイズ
 * @returns {Array[]} 星型の座標配列
 */
export const makeStarSymbol = function(size) {

  const base = 238;
  const symbol = [[0,-113],[29,-27],[119,-27],[47,27],[73,113],[0,62],[-73,113],[-47,27],[-119,-27],[-29,-27],[0,-113]];

  return symbol.map(v => {
    return [
      v[0] * size / base,
      v[1] * size / base
    ];
  });

};

/**
 * 三角型のシンボルを描画するための座標配列を返却する.
 * @param {number} size サイズ
 * @returns {Array[]} 三角型の座標配列
 */
export const makeTriangleSymbol = function(size) {

  var base = 10;
  var symbol = [[0,-5], [5,5], [-5,5], [0,-5]];

  return symbol.map(v => {
    return [
      v[0] * size / base,
      v[1] * size / base
    ];
  });

};

/**
 * 度を分に変換する.
 * @param {number|string} degree 度
 * @returns {number} 分
 */
export const d2m = (degree) => {
  return parseFloat(degree) * 60.0;
};

/**
 * 分を度に変換する.
 * @param {number|string} minutes 分
 * @returns {number} 度
 */
export const m2d = (minutes) => {
  return parseFloat(minutes) / 60.0;
};

/**
 * 度をラジアンに変換する.
 * @param {number} deg 度
 * @returns {number} ラジアン
 */
export const deg2rad = (deg) => {
  return deg * Math.PI / 180;
};

/**
 * 度をラジアンに変換する.
 * @param {number} rad ラジアン
 * @returns {number} 度
 */
export const rad2deg = (rad) => {
  return rad * 180 / Math.PI;
};

/**
 * 角度を0<=degree<360の範囲に正規化し返却する.
 * @param degree 角度
 * @returns {number} 正規化された角度
 */
export const normalizeDegree = (degree) => {
  while (degree < 0) {
    degree += 360;
  }
  return degree % 360;
};

/**
 * 2つのベクトルのなす角の中間の角度を算出する。
 * 
 * @param {number[]|LonLat} o 基点となる座標
 * @param {number[]|LonLat} p1 ベクトル1
 * @param {number[]|LonLat} p2 ベクトル2
 * @returns {number} 算出した角度
 */
export const calcMiddleAngle = (o, p1, p2) => {

  let xy, xy1, xy2;
  if (Array.isArray(o)) {
    xy = WRAP.Geo.getScreenPoint(convertWRAPPoint(o[1], o[0]));
  } else {
    xy = WRAP.Geo.getScreenPoint(convertWRAPPoint(o.lat, o.lon));
  }

  if (Array.isArray(p1)) {
    xy1 = WRAP.Geo.getScreenPoint(convertWRAPPoint(p1[1], p1[0]));
  } else {
    xy1 = WRAP.Geo.getScreenPoint(convertWRAPPoint(p1.lat, p1.lon));
  }

  if (Array.isArray(p2)) {
    xy2 = WRAP.Geo.getScreenPoint(convertWRAPPoint(p2[1], p2[0]));
  } else {
    xy2 = WRAP.Geo.getScreenPoint(convertWRAPPoint(p2.lat, p2.lon));
  }

  var a = [xy2.x - xy.x, xy2.y - xy.y];
  var b = [xy1.x - xy.x, xy1.y - xy.y];
  // var angle = (Math.atan2(a[1], a[0]) + Math.atan2(b[1], b[0])) / 2;
  // return rad2deg(angle);

  let angle = 0;
  let count = 0;
  [a, b].forEach(a => {
    if(a[0] !== 0 || a[1] !== 0) {
      angle += Math.atan2(a[1], a[0]);
      count++;
    }
  });
  if(count === 0) {
    return angle;
  // } else if(count === 1) {
  //   return normalizeDegree(rad2deg(angle) + 90);
  } else {
    return normalizeDegree(rad2deg(angle / count));
  }

};

/**
 * フィートをメートルに変換する
 * @parame {number} フィート
 * @return {number} メートル
 */
export const ft2m = ft => {
  return ft * 0.3048;
};


/**
 * メートルをフィートに変換する
 * @parame {number} メートル
 * @return {number} フィート
 */
export const m2ft = m => {
  return m / 0.3048;
};

const _1kt = 1852.0 / 3600;
/**
 * 秒速メートルをノットに変換する
 * @parame {number} 秒速メートル
 * @return {number} ノット
 */
export const mps2kt = mps => {
  return mps / _1kt;
}

/**
 * ノットを秒速メートルに変換する
 * @parame {number} ノット
 * @return {number} 秒速メートル
 */
export const kt2mps = kt => {
  return kt * _1kt;
}

/**
 * 国際標準大気モデルにおいて、高度から気圧を算出する。
 * @param {number} h 高度(m)
 * @returns {number} 気圧(hPa/mb)
 * @exception 0m未満および20,000m超の高度を指定された場合
 */
export const calcPressureFromAlt =(h) => {

  if( h < 0 || h > 20000 ) {

    throw new Error('out of range');

  }

  if( h < 11000 ) {

    // 0 - 11,000 m
    //
    // P0 * ( 1 - ( 0.0065 * h ) / T0 ) ** 5.257
    //
    // P0: 1013.25 hPa
    // T0: 15 ℃ = 288.15 K
    return 1013.25 * Math.pow( 1 - ( 0.0065 * h ) / 288.15, 5.257 );
  } else {

    // 11,000 - 20,000 m
    //
    // P0 * exp( g / 286.95 * ( 11000 - h ) / T0 );
    //
    // P0: 226.32 hPa
    // g: 9.81 m/s/s
    // T0: -56.5 ℃ = 216.65 K
    return 226.32 * Math.exp( 9.81 / 286.95 * ( 11000 - h ) / 216.65 );
  }

};

function nsew(n, isLat) {
  if (isLat) {
    if (n === 0) return '';
  } else {
    if (n % 180 === 0) return ''
  }
  const dir = ['N', 'S', 'E', 'W'];
  const idx = isLat ? 0 : 2;
  return n > 0 ? dir[idx] : dir[idx + 1];
}

function fmtDM(n) {
  const depth = 10;
  const abs = Math.abs(n);
  const d = Math.floor(abs);
  const m = (abs - d) * 60;
  const mi = Math.floor(m * depth) / depth;
  return `${d}°${mi}`
}

function splitDMS(degree) {
  let d = Math.abs(degree);
  const sign = Math.sign(degree);
  const deg = Math.floor(d);
  d -= deg;
  const min = Math.floor(d * 60);
  d -= min / 60;
  const sec = d * 3600;
  return [sign, deg, min, sec];
}

/**
 * 文字列が示す日時(UTC)のDateインスタンスを返却します.
 * @param {string} str 日時文字列
 * @returns {Date} Dateインスタンス 日時として解釈できなかった場合はnull
 */
export const parseUTCDate = str => {

  let dateList;
  if((dateList = /^(\d{4})[/\- ]?(\d{1,2})[/\- ]?(\d{1,2})[T ]?(\d{1,2})[: ]?(\d{1,2})[: ]?(\d{1,2})Z?$/.exec(str)) !== null) {
    dateList = dateList.slice(1);
    dateList[1]--;
  } else if((dateList = /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[/\- ](\d{1,2})[/\- ](\d{4}) (\d{1,2})[: ]?(\d{1,2})[: ]?(\d{1,2})$/i.exec(str)) !== null) {
    dateList = dateList.slice(1);
    const month = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"].indexOf(dateList[0].toLowerCase());
    dateList[0] = dateList[2];
    dateList[2] = dateList[1];
    dateList[1] = month;
  }

  if(dateList) {
    return new Date(Date.UTC.apply(Date, dateList));
  }
  return null;
}

/**
 * 日時のDateインスタンスを指定の書式で整形し返却します.
 * 日時はUTCに基づきます.
 * @param {Date} date Dateインスタンス
 * @param {string} [fmt] 日付書式
 * @returns {string} 整形された日時
 */
export const formatUTCDate = (date, fmt) => {
  if(!date) {
    return;
  }
  if(!fmt) {
    fmt = '%Y/%m/%d %H:%M:%S';
  }

  return fmt.replace(/%[_-]?[a-zA-Z%]/g, (match) => {

    let idx = 1;
    let padding;
    switch(match.charAt(1)) {
      case '-':
        idx++;
        padding = '';
        break;
      case '_':
        idx++;
        padding = ' ';
        break;
      default:
        padding = '0';
        break;
    }

    switch(match.charAt(idx)) {
      //Date
      case 'Y':
        return date.getUTCFullYear();
      case 'm':
        return (padding + (date.getUTCMonth() + 1)).slice(-2);
      case 'd':
        return (padding + date.getUTCDate()).slice(-2);
      case 'a':
        return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][date.getUTCDay()];
      case 'A':
        return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][date.getUTCDay()];
      case 'b':
        return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][date.getUTCMonth()];
      case 'B':
        return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][date.getUTCMonth()];
      case 'w':
        return date.getUTCDay();
      //Time
      case 'H':
        return (padding + date.getUTCHours()).slice(-2);
      case 'k':
        return date.getUTCHours();
      case 'I':
        return (padding + (date.getUTCHours() % 12 === 0 ? 12 : date.getUTCHours() % 12)).slice(-2);
      case 'l':
        return date.getUTCHours() % 12 === 0 ? 12 : date.getUTCHours() % 12;
      case 'M':
        return (padding + date.getUTCMinutes()).slice(-2);
      case 'S':
        return (padding + date.getUTCSeconds()).slice(-2);
      case 'p':
        return date.getUTCHours() < 12 ? 'AM' : 'PM';
      case '%':
        return '%';
      default:
        return;
    }

  });

}
/**
 * 時制パネル用Basetimeフォーマット.
 * @param time
 * @return {string}
 */
export const formatBaseTime = time => {
  return `(Base: ${formatUTCDate(parseUTCDate(time), '%m/%d %H:%MZ')})`;
}
/**
 * 時制パネル用Validtimeフォーマット.
 * @param time
 * @return {string}
 */
export const formatValidTime = time => {
  return `Valid: ${formatUTCDate(parseUTCDate(time), '%Y/%m/%d %H:%MZ')}`;
}
/**
 * 時制パネル用Issuetimeフォーマット.
 * @param time
 * @return {string}
 */
 export const formatIssueTime = time => {
  return `(Issue: ${formatUTCDate(parseUTCDate(time), '%m/%d %H:%MZ')})`;
}

/**
 * ランダムなIDを生成する.
 * @return {string}
 */
export const uuid = () => {
  const d = +new Date();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    .replace(/[xy]/g, function(c) {
      const r = (d + Math.random() * 16) % 16 | 0;
      // eslint-disable-next-line
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
};

/**
 * 空チェック.
 * isEmpty(null)
 *  →true
 * isEmpty(undefined)
 *  →true
 * isEmpty("")
 *  →true
 * isEmpty(1)
 *  →true
 * isEmpty(0)
 *  →true
 * isEmpty([])
 *  →true
 * isEmpty({})
 *  →true
 * isEmpty("a")
 *  →false
 * isEmpty([1])
 *  →false
 * isEmpty([{a:1}])
 *  →false
 * @param value
 * @return {boolean}
 */
export const isEmpty = (value) => {
  if (value === null || value === undefined) {
    return true;
  }
  if (typeof value.length === 'number') {
    return !value.length;
  }
  if (typeof value.size === 'number') {
    return !value.size;
  }
  const type = Object.prototype.toString.call(value).slice(8, -1)
  if (type === 'Object') {
    return !Object.keys(value).length;
  }
  return true;
};

/**
 * Object比較.
 * isEqualObject({a:1,b:2},{a:1,b:2})
 *  →true
 * isEqualObject({a:1,b:2},{b:2,a:1})
 *  →true
 * isEqualObject({a:1,b:2,nest:{c:3}},{nest:{c:3},b:2,a:1})
 *  →true
 * isEqualObject({a:['a']},{a:['a']})
 *  →true
 * isEqualObject(['a',{a:1,b:2}],['a',{b:2,a:1}])
 *  →true
 * isEqualObject({a:1,b:2},{a:1,b:9})
 *  →false
 * @param a
 * @param b
 * @return {boolean}
 */
export const isEqualObject = (a, b) => {
  if (a === b) return true;

  if (typeof a !== 'object' || typeof b !=='object') {
    return false;
  }

  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);

  if (aKeys.length !== bKeys.length) {
    return false;
  }

  for (let key of aKeys) {
    if (!bKeys.includes(key)) {
      return false;
    }
    if (!isEqualObject(a[key], b[key])) {
      return false;
    }
  }
  return true;
}

export const getProperty = (obj, deepKey) => {
  const path = deepKey.split('.');
  let index = 0;
  const length = path.length;
  while (obj != null && index < length) {
    obj = obj[path[index]];
    index++;
  }
  return (index && index === length) ? obj : undefined;
}

export const extractBy = (list, property, comparator) => {
  let result = undefined;
  if (!list || list.length === 0 || !property || !comparator) return result;

  let iteratee;
  if (typeof property === 'function') {
    iteratee = property;
  } else {
    iteratee = getProperty;
  }
  let index = -1;
  let computed = undefined ;
  while (++index < list.length) {
    let value = list[index];
    let current = iteratee(value, property);
    if (current != null) {
      if (computed === undefined) {
        computed = current;
        result = value;
      } else {
        if (comparator(current, computed)) {
          computed = current;
          result = value;
        }
      }
    }
  }
  return result;
}

export const maxBy = (list, property) =>{
  return extractBy(list, property, (a, b) => {
    return a > b
  });
}

export const minBy = (list, property) =>{
  return extractBy(list, property, (a, b) => {
    return a < b
  });
}

//lodash解禁関数
export const _groupBy = groupBy;
export const _orderBy = orderBy;
